import { render, staticRenderFns } from "./DashboardField.vue?vue&type=template&id=ff5e07b8&"
import script from "./DashboardField.vue?vue&type=script&lang=js&"
export * from "./DashboardField.vue?vue&type=script&lang=js&"
import style0 from "./DashboardField.vue?vue&type=style&index=0&id=ff5e07b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports